let isLoading = false

const loadItems = (button) => {
	if (isLoading) return

	const totalPagesInput = document.querySelector('[data-total-pages]')
	const currentPageInput = document.querySelector('[data-current-page]')
	const nextUrlInput = document.querySelector('[data-next-url]')
	if (!totalPagesInput || !currentPageInput || !nextUrlInput) return

	const totalPages = parseInt(totalPagesInput.value, 10)
	let currentPage = parseInt(currentPageInput.value, 10)
	let currentPageScroll = currentPage + 1

	currentPage = currentPage + 1

	const rawValue = nextUrlInput.value

	const getUrlWithoutPhcursor = (value, pageValue) => {
		const url = new URL(value, window.location.origin)

		const currentParams = new URLSearchParams(window.location.search)
		for (const [key, val] of currentParams.entries()) {
			if (!url.searchParams.has(key)) {
				url.searchParams.set(key, val)
			}
		}

		url.searchParams.set('page', pageValue)
		url.searchParams.delete('phcursor')

		return url.pathname + '?' + url.searchParams.toString()
	}

	const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage)
	const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll)

	currentPageInput.value = String(currentPage)

	button.setAttribute('disabled', '')
	button.classList.add('loading')

	isLoading = true

	fetch(nextUrl)
		.then((response) => {
			if (!response.ok) throw new Error('Failed to load more items')
			return response.text()
		})
		.then((responseHTML) => {
			const parser = new DOMParser()
			const doc = parser.parseFromString(responseHTML, 'text/html')
			const incomingGrid = doc.querySelector('.load-more-grid')
			const targetGrid = document.querySelector('.load-more-grid')
			if (!incomingGrid || !targetGrid) return

			const addedCount = incomingGrid.querySelectorAll(':scope > li').length
			targetGrid.insertAdjacentHTML('beforeend', incomingGrid.innerHTML)

			try {
				colorSwatches()
			} catch (err) {}
			if (typeof announceProductGridUpdate === 'function' && addedCount > 0) {
				const template = window.accessibilityStrings?.productsLoaded
				const message = template
					? template.replace('[count]', addedCount)
					: `${addedCount} more products loaded`
				announceProductGridUpdate(message)
			}
			if (typeof hideDuplicateButtonLabels === 'function') {
				hideDuplicateButtonLabels(document.getElementById('ProductGridContainer'))
			}
		})
		.catch(() => {})
		.finally(() => {
			isLoading = false

			if (currentPage <= totalPages) {
				const scollData = document.querySelector('.infinite-scroll__data')
				if (scollData && currentPage != totalPages) {
					scollData.querySelector('input[data-next-url]').dataset.nextUrl =
						nextUrlScroll
					scollData.querySelector('input[data-next-url]').value = nextUrlScroll
					scollData.querySelector(
						'input[data-current-page]'
					).dataset.currentPage = currentPage
					scollData.querySelector('input[data-current-page]').value =
						currentPage
					checkVisibility()
				}

				button.removeAttribute('disabled')
				button.classList.remove('loading')

				if (currentPage == totalPages) {
					button.remove()
				}
			}
		})
}

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll('.js-infinite-scroll')
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner)
				}
			})
		})

		sectionObserver.observe(spinner);
	})
}

function loadMore() {
	document.querySelectorAll('.js-load-more').forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		}
	})

	checkVisibility();
}

(function () {
	loadMore();
})();
